import {FC, forwardRef} from 'react';
import {IMaskInput} from 'react-imask';

const mask = 'NUM #EXT';

export const PhoneMask: FC<any> = forwardRef((props, ref) => {
  const {onChange, ...other} = props;

  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      onAccept={onChange}
      mask={mask}
      blocks={{
        NUM: {
          mask: '+7 (*00) 000-00-00',
          definitions: {
            '*': /[1-9]/,
          },
        },
        EXT: {
          mask: '0000',
        },
      }}
      label="Номер телефона"
      autofix
      overwrite
    />
  );
});
